/** Cloudflare Turnstile site key (public, safe in the frontend bundle). */
export const turnstileSiteKey = (process.env.REACT_APP_TURNSTILE_SITE_KEY || "").trim();

/** Shown inline next to the widget (signup + verify flows). */
export const TURNSTILE_REQUIRED_MESSAGE = "Complete the security check below.";

/**
 * When Cloudflare returns `timeout-or-duplicate`, the token was already verified or expired.
 * Tell the user exactly what to do next (avoid raw API jargon).
 */
export const TURNSTILE_STALE_OR_REUSED_USER_MESSAGE = [
  "That security check timed out or was already used. That usually happens if this page was open a long time, or you tried again after a mistake.",
  "",
  "What to do next:",
  "1. Complete the security check again below and wait until it finishes.",
  "2. Then submit or resend your code once.",
  "3. If you still see this message, refresh the page and try again.",
].join("\n");

/**
 * Map Turnstile / API error text to friendly copy where we recognize it.
 *
 * @param {unknown} rawMessage
 * @returns {string}
 */
export function formatTurnstileErrorForUser(rawMessage) {
  const m = String(rawMessage || "").toLowerCase();
  if (m.includes("timeout-or-duplicate") || m.includes("timeout or duplicate")) {
    return TURNSTILE_STALE_OR_REUSED_USER_MESSAGE;
  }
  return String(rawMessage || "Something went wrong. Please try again.");
}

export function isTurnstileEnabled() {
  return Boolean(turnstileSiteKey);
}
